<template>
   <b-button
      @click="() => { showModal = true }"
      size="sm"
      :variant="(httpRequestInProgress) ? 'success': 'primary'"
      block
    ><!-- button -->
      <span v-if="httpRequestInProgress">
      <b-spinner
         type="grow"
         label="Loading..."
         small
      ></b-spinner>
      </span>
      <span v-else>In Direkteinlagerung verschieben</span>
      <b-modal id="modal-direct-stocking"
         v-model="showModal"
         title="in Direkteinlagerung verschieben"
         @ok="handleOk"
         cancel-title="abbrechen"
         size="md"
      >
        <b-form-group>
          <p>
          <label>
            Zustand
          </label>
          <b-form-select
              v-model="selectedCondition"
              :options="conditions"
              text-field="text"
              value-field="value"
          ></b-form-select>
          </p>
          <p>
            <label>
              Menge
            </label>
            <b-form-input
                v-model="selectedQuantity"
                :min="1"
                :max="customerOrder.customerorderitems[0].quantity"
                type="number"
            >
            </b-form-input>
          </p>
          <p>{{errorMessage}}</p>
        </b-form-group>
      </b-modal>
   </b-button>
</template>
<script>
export default {
   props: ['customerOrder','authorization' ],
   data() {
      return {
        showModal: false,
        disabled: false,
        httpRequestInProgress: false,
        conditions: [],
        conditionsData: [],
        selectedCondition: null,
        showQuantitySelection: false,
        selectedQuantity: 1,
        errorMessage: "",
      };
   },
  computed: {

  },
  methods: {
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      if(!this.validateInput()) return;

      const conditionData = this.conditions.find(condition => condition.value == this.selectedCondition);
      this.httpRequestInProgress = true;

      const req = {
        origin: conditionData.origin, //Origin 1= Wareneingang, 2 = Retoure, 3 = Ausschussware only 2 or 3 relevant here
        condition: conditionData?.cint ? conditionData.text.substring(0,1) : conditionData.condition,
        quantity: this.selectedQuantity,
        customItemNoteTemplateId: conditionData.cint,
        customerOrderItem: this.customerOrder.customerorderitems[0],
      }

      axios.post('/customerorder/action/direct_stocking', req).then(res => {
        this.httpRequestInProgress = false;
        this.showModal = false;
        this.errorMessage = "";
      }).catch(error => {
        console.log(error);
        const errorString = error.response?.data?.message ?? error.response?.data ??  error.message ?? error;
        this.errorMessage = "Ein Fehler ist auggetreten: "+ errorString;
        this.httpRequestInProgress = false;
      });
    },
    validateInput() {
      // validate Condition
      if(this.selectedCondition === null) {
        this.errorMessage = "Bitte wählen Sie einen Zustand aus";
        return false;
      }
      //validate Quantity
      // return true if the selected quantity is less than or equal to the quantity of the customer order item
      const isQuantityValid = (this.selectedQuantity > 0 && this.selectedQuantity <= this.customerOrder.customerorderitems[0].quantity);
      if(!isQuantityValid) {
        //change the error message
        this.errorMessage = "Die Menge "+ this.selectedQuantity +" darf nicht größer als die Bestellmenge "+ this.customerOrder.customerorderitems[0].quantity +" sein";
        return false;
      }
      return true;
    },
  },
  created() {
    // here we try to merge the l2 scanner condition with the l0 scanner conditions
    axios.get('/customitemnote/template/all').then(res => {
      const arrayItem =           [
        {condition: 1, text: "NEW", origin: 2},
        {condition: 2, text: "SH", origin: 2},
        {condition: 3, text: "SHY", origin: 2},
        {value: null, text: "------------", disabled: true },
        {value: null, text: "Ausschussware", disabled: true },
      ]
      const customItemNoteTemplates = res.data.map(customItemNoteTemplate => {
        return {cint: customItemNoteTemplate.id, text: customItemNoteTemplate.name, origin: 3} //cint = custom item note template
      });
      this.conditions = arrayItem.concat(customItemNoteTemplates);

      this.conditions = this.conditions.map((condition, id) => {
        condition.value =  id;  return condition;
      });
    });
  }
}
</script>
